import { GET } from '../request'

export const getAsignaturas = () =>
  GET('/api/profes/planificacion/asignatura/list')
